import { Injectable } from '@angular/core';
import { ExploreService } from './explore-service';
import { EventService } from '../internal/event-service';
//import { Sighting } from '../../models/models';
import { HttpClient } from '@angular/common/http';
import { LanguageService } from '../internal/language-service';
//import { /*NgbDate*/ /*NgbDateStruct*/ } from '@ng-bootstrap/ng-bootstrap';

import { first } from 'rxjs';
import { Sighting } from '@spotter/models/sighting';
import { MultipleChoiceQuestion, QuestionsService } from './questions-service';



export interface DateStruct {
    /**
     * The year, for example 2016
     */
    year: number;
    /**
     * The month, for example 1=Jan ... 12=Dec
     */
    month: number;
    /**
     * The day of month, starting at 1
     */
    day: number;
}



export class DateStuctClass implements DateStruct {
	/**
	 * The year, for example 2016
	 */
	year: number;

	/**
	 * The month, for example 1=Jan ... 12=Dec as in ISO 8601
	 */
	month: number;

	/**
	 * The day of month, starting with 1
	 */
	day: number;

	/**
	 * A **static method** that creates a new date object from the `NgbDateStruct`,
	 *
	 * ex. `NgbDate.from({year: 2000, month: 5, day: 1})`.
	 *
	 * If the `date` is already of `NgbDate` type, the method will return the same object.
	 */
	static from(date?: DateStruct | null): DateStuctClass | null {
		if (date instanceof DateStuctClass) {
			return date;
		}
		return date ? new DateStuctClass(date.year, date.month, date.day) : null;
	}

	constructor(year: number, month: number, day: number) {
		this.year = isInteger(year) ? year : <any>null;
		this.month = isInteger(month) ? month : <any>null;
		this.day = isInteger(day) ? day : <any>null;
	}

	/**
	 * Checks if the current date is equal to another date.
	 */
	equals(other?: DateStruct | null): boolean {
		return other != null && this.year === other.year && this.month === other.month && this.day === other.day;
	}

	/**
	 * Checks if the current date is before another date.
	 */
	before(other?: DateStruct | null): boolean {
		if (!other) {
			return false;
		}

		if (this.year === other.year) {
			if (this.month === other.month) {
				return this.day === other.day ? false : this.day < other.day;
			} else {
				return this.month < other.month;
			}
		} else {
			return this.year < other.year;
		}
	}

	/**
	 * Checks if the current date is after another date.
	 */
	after(other?: DateStruct | null): boolean {
		if (!other) {
			return false;
		}
		if (this.year === other.year) {
			if (this.month === other.month) {
				return this.day === other.day ? false : this.day > other.day;
			} else {
				return this.month > other.month;
			}
		} else {
			return this.year > other.year;
		}
	}
}

function isInteger(value: any): value is number {
	return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}


/** A filter, containing the filter options and other relevant data */
export class Filter {
    filters: Array<FilterOption> = [];
    activeCount: number = 0;
    //enabledNumber: string = "";
    isActive: boolean = false;

    /** Create a new filter with an array of options */
    constructor(filters: Array<FilterOption>) {
        this.filters = filters;
        this.countActive();
    }

    /** Recalcualtes the number of active filters */
    countActive() {
        let counter = 0;
        this.filters.forEach(f => {
            if (f.checked)
                counter++;
        })
        this.activeCount = counter;
        //this.enabledNumber = `${this.activeCount}/${this.filters.length}`;
        this.isActive = this.activeCount < this.filters.length;
    }

    /** Returns the text or ids of the active filters */
    asString(): string {

        if (!this.isActive)
            return "all";


        let result = "";

        this.filters.forEach(f => {
            if (f.checked)
            {
                if (f.id == undefined)
                    result += f.text;
                else
                    result += f.id;
                result += ",";
            }
        });
        
        return result;
    }
}

/** An option that a filter can check */
export interface FilterOption {
    text: string;
    id?: number;
    checked: boolean;
}

/** A filter with a string key */
export interface KeyedFilter {
    filter: Filter;
    key: string;
}

@Injectable({ providedIn: 'root' })
export class FilterService {


  //  userEnteredString: string = "";

    filteredSightings?: Array<Sighting>;
    totalNumber: number = 0;
    activeFilterCount: number = 0;
    totalFilterCount: number = 0;
    customTextCount: number = 0;

    // The non-indexable options
    countries!: Filter;
    species!: Filter;

    // The indexable options
    research_grade!: Filter;
    algae!: Filter;
    boats!: Filter;
    depth!: Filter;
    extensive!: Filter;
    fishing!: Filter;
    flowers!: Filter;
    intertidal!: Filter;
    shootLength!: Filter;
    percentage_cover!: Filter;
    moorings!: Filter;
    observe!: Filter;
    sediment!: Filter;

    indexableFilters: KeyedFilter[] = [];


    dateUploadedFrom: DateStruct | null = null;
    dateUploadedTo: DateStruct | null = null;
    dateSpottedFrom: DateStruct | null = null;
    dateSpottedTo: DateStruct | null = null;

    firstUploadYear: number = 2000;
    firstSpottedYear: number = 2000;

    // User Strings
    damages!: Filter;
    //changes!: Filter;
    water_temperature_measurement!: Filter;
    recreational_activity!: Filter;
    additionalSpecies!: Filter;
    fishingGear!: Filter;
    fishingCaught!: Filter;

    // New numeric questions
    flowering_density!: Filter;
    fruiting_density!: Filter;
    number_of_seeds!: Filter;
    seed_length!: Filter;
    water_temperature!: Filter;


    textFilters: KeyedFilter[] = [];

    //  availableCountries: Array<string> = [];

    /** The constructor */
    constructor(public explore: ExploreService, public events: EventService, private http: HttpClient, private lang: LanguageService, public questions: QuestionsService) {
        this.events.sightingDeleted.subscribe(() => { this.filter(); });
        this.events.sightingChanged.subscribe(() => { this.filter(); });
        this.events.sightingCreated.subscribe(() => { this.filter(); });
    }


    


    /** Initialises the filter, loading the question data and the sightings.
     * 
     *  You should call this after you have loaded all the sightings in the explore service.
     *  In practive, you don't need to call this as it's ran as part of the APP_INITIALIZER process.
     */
    async initialise()
    {
        //await this.loadQuestionData();
        this.loadFilterOptions();
        
       this.calculateDateRanges();

        // Run the filter to make sure we have data populated
        this.filter();
    }



    /** Finds out the first spotted/upload date for a better UX in the datepicker. 
     *  // TODODO: Should we always do this when the sightings have updated
    */
    private calculateDateRanges()
    {
        let firstUploadDay = new Date();
        let firstSpottedDay = new Date();

        this.explore.sightings.forEach(s => {
            let thisUploadDay = new Date(s.created_at!);
            if (thisUploadDay < firstUploadDay)
                firstUploadDay = thisUploadDay;

            let thisSpottedDay = new Date(s.date_spotted!);
            if (thisSpottedDay < firstSpottedDay)
                firstSpottedDay = thisSpottedDay;
        });

        this.firstUploadYear = firstUploadDay.getUTCFullYear();
        this.firstSpottedYear = firstSpottedDay.getUTCFullYear();      
    }



    /** Applies the filter
     *  Runs though all the options and drops any that aren't checked
     */
    filter() {
        this.totalNumber = this.explore.sightings.length;

        this.filteredSightings = this.explore.sightings.filter(
            sighting => {

                // Checks the checked array of countries for a match
                let hasCountry = false;
                this.countries!.filters.forEach(country => {
                    if (sighting.country == country.text && country.checked)
                        hasCountry = true;
                });
                this.countries!.countActive();
                if (!hasCountry)
                    return false;

                // Checks the checked array of species for a match
                let hasSpecies = false;
                this.species!.filters.forEach(species => {
                    sighting.species.forEach(s => {
                        if (s.display_name == species.text && species.checked)
                            hasSpecies = true;
                    })
                });
                this.species!.countActive();
                if (!hasSpecies)
                    return false;

                  
                    

                // Check all indexable filters
                for (var i = 0; i < this.indexableFilters.length; i++)
                    if (!this.checkForIndex(sighting, this.indexableFilters[i].filter, this.indexableFilters[i].key))
                        return false;


                // Check all text filters
                for (var i = 0; i < this.textFilters.length; i++)
                {
                    let s: any = sighting;
                    this.textFilters[i].filter.countActive();

                    // Check for wanting empty 
                    if (!this.textFilters[i].filter.filters[0].checked && !s[this.textFilters[i].key])
                        return false;

                    // Check for wanting values
                    if (!this.textFilters[i].filter.filters[1].checked && s[this.textFilters[i].key])
                        return false;
                }


                // Checks if the date is is range
                let creationDateJS = new Date(sighting.created_at!);
                let date: DateStuctClass = new DateStuctClass(
                    creationDateJS.getUTCFullYear(),
                    creationDateJS.getUTCMonth() + 1,
                    creationDateJS.getUTCDate()
                );

                let spottedDateJS = new Date(sighting.date_spotted!);
                let dateS: DateStuctClass = new DateStuctClass(
                    spottedDateJS.getUTCFullYear(),
                    spottedDateJS.getUTCMonth() + 1,
                    spottedDateJS.getUTCDate()
                );

                if (this.dateUploadedFrom != null && date.before(this.dateUploadedFrom))
                    return false;

                if (this.dateUploadedTo != null && date.after(this.dateUploadedTo))
                    return false;

                if (this.dateSpottedFrom != null && dateS.before(this.dateSpottedFrom))
                    return false;

                if (this.dateSpottedTo != null && dateS.after(this.dateSpottedTo))
                    return false;
                    



                // If we reach here it must be a selected sighting
                return true;

            });

        this.activeFilterCount = 0;
        this.indexableFilters.forEach(f => {
            if (f.filter.isActive)
                this.activeFilterCount++;
        });

        this.textFilters.forEach(f => {
            if (f.filter.isActive)
                this.activeFilterCount++;
        });

        if (this.countries!.isActive)
            this.activeFilterCount++;

        if (this.species!.isActive)
            this.activeFilterCount++;


        this.totalFilterCount = this.indexableFilters.length
        this.totalFilterCount += this.textFilters.length;
        this.totalFilterCount += 2; // Add for country and species

        this.events.filterChanged.emit();
    }

    /** Checks that a sighting has a matching index
     *  @param  sighting    The Sighting to check
     *  @param  options     The array of FilterOptions to check against
     *  @param  keyName     The key of the sighting to check the index of
     */
    checkForIndex(sighting: Sighting, filter: Filter, keyName: string): boolean {
        let s: any = sighting;
        let matches = false;
        filter.filters.forEach(option => {
            if (option.id == s[keyName] && option.checked)
                matches = true;
        });
        filter.countActive();

        return matches;
    }


    /** Loads all of the options for the filters */
    loadFilterOptions() {
        this.countries = new Filter(this.loadStringOptionsFromArray(this.explore.sightings, "country"));
        this.species = new Filter(this.loadSpeciesFromArray(this.explore.sightings));

        this.algae = this.createFilterWithOptions('algae', this.questions.sightingQuestions.algae);
        this.depth = this.createFilterWithOptions('depth', this.questions.sightingQuestions.depth);
        this.boats = this.createFilterWithOptions('boats', this.questions.sightingQuestions.boats);
        this.extensive = this.createFilterWithOptions('extensive', this.questions.sightingQuestions.extensive);
        this.fishing = this.createFilterWithOptions('fishing', this.questions.sightingQuestions.fishing);
        this.flowers = this.createFilterWithOptions('flowers', this.questions.sightingQuestions.flowers);
        this.intertidal = this.createFilterWithOptions('intertidal', this.questions.sightingQuestions.intertidal);
        this.shootLength = this.createFilterWithOptions('length', this.questions.sightingQuestions.length);
        this.percentage_cover = this.createFilterWithOptions('percentage_cover', this.questions.sightingQuestions.percentage_cover);
        this.moorings = this.createFilterWithOptions('moorings', this.questions.sightingQuestions.moorings);
        this.observe = this.createFilterWithOptions('observe', this.questions.sightingQuestions.observe);
        this.sediment = this.createFilterWithOptions('sediment', this.questions.sightingQuestions.sediment);

        this.damages = new Filter(this.loadUserTextFilters());
        //this.changes = new Filter(this.loadUserTextFilters());
        this.fishingCaught = new Filter(this.loadUserTextFilters());
        this.fishingGear = new Filter(this.loadUserTextFilters());
        this.additionalSpecies = new Filter(this.loadUserTextFilters());
        this.recreational_activity = new Filter(this.loadUserTextFilters());
        this.water_temperature_measurement = new Filter(this.loadUserTextFilters());

        this.textFilters.push({ filter: this.damages, key: 'damages' });
        //this.textFilters.push({ filter: this.changes, key: 'changes' });
        this.textFilters.push({ filter: this.fishingCaught, key: 'fishing_caught' });
        this.textFilters.push({ filter: this.fishingGear, key: 'fishing_gear' });
        this.textFilters.push({ filter: this.additionalSpecies, key: 'additional_species' });

        this.flowering_density = new Filter(this.loadUserTextFilters());
        this.fruiting_density = new Filter(this.loadUserTextFilters());
        this.number_of_seeds = new Filter(this.loadUserTextFilters());
        this.seed_length = new Filter(this.loadUserTextFilters());
        this.water_temperature = new Filter(this.loadUserTextFilters());

        this.textFilters.push({ filter: this.flowering_density, key: 'flowering_density' });
        this.textFilters.push({ filter: this.fruiting_density, key: 'fruiting_density' });
        this.textFilters.push({ filter: this.number_of_seeds, key: 'number_of_seeds' });
        this.textFilters.push({ filter: this.seed_length, key: 'seed_length' });
        this.textFilters.push({ filter: this.water_temperature, key: 'water_temperature' });
        this.textFilters.push({ filter: this.water_temperature_measurement, key: 'water_temperature_measurement' });
        this.textFilters.push({ filter: this.recreational_activity, key: 'recreational_activity' });

        let options = new Array<FilterOption>;
        options.push({ text: "research_grade", checked: true, id: 0 });
        options.push({ text: "research_grade", checked: true, id: 1 });
        options.push({ text: "research_grade", checked: true, id: 2 });
        options.push({ text: "research_grade", checked: true, id: 3 });

        let newFilter = new Filter(options);
        this.indexableFilters.push({ filter: newFilter, key: 'research_grade' });
        this.research_grade = newFilter;
    }


    /** Creates a filter from a `MultipleChoiceQuestion` */
    createFilterWithOptions(key: string, answers: MultipleChoiceQuestion)
    {
        // Create the options
        let options = new Array<FilterOption>;

        options.push({ text: "filters.no_data", checked: true, id: 0 });

        for (let key in answers.a)
            options.push({ text: answers.a[key], checked: true, id: +key });

        // Add to the array of indexable filters
        let newFilter = new Filter(options);
        this.indexableFilters.push({ filter: newFilter, key: key });

        return newFilter;
    }



    loadUserTextFilters() {
        let options = new Array<FilterOption>;
        options.push({ text: "filters.no_data", checked: true, id: 0 });
        options.push({ text: "filters.user_data", checked: true, id: 1 });
        return options;
    }


    /** Loads the available string options from an array of objects
     *  Used to load all the available countries
     *  @param  arrayToSearch   The array of objects
     *  @param  childName       The child property name
     *  @param  alsoSort        Whether to also sort alphabetically
     *  @returns                An array of `FilterOption`s
     */
    loadStringOptionsFromArray(arrayToSearch: Sighting[], childName: string, alsoSort: boolean = true) {
        // Dump into a set to handle duplicates
        let set: Set<string> = new Set<string>();
        for (let i = 0; i < arrayToSearch.length; i++)
        {
            const obj: any = arrayToSearch[i];
            if (obj.hasOwnProperty(childName))
                set.add(obj[childName]);
            else
                console.warn("Unable to get child name " + childName);
        }

        // Convert to an array
        let options = new Array<FilterOption>;

        set.forEach(c => {
            options.push({ text: c, checked: true });
        });

        if (alsoSort)
        {
            options.sort(function (a: FilterOption, b: FilterOption) {
                if (a.text < b.text) return -1;
                if (a.text > b.text) return 1;
                return 0;
            });
        }

        return options;
    }


    /** Loads the available species from the array of sightings */
    loadSpeciesFromArray(arrayToSearch: Sighting[]) {
        let set: Set<string> = new Set<string>();
        for (let i = 0; i < arrayToSearch.length; i++)
        {
            const obj = arrayToSearch[i];
            arrayToSearch[i].species.forEach(s => {
                set.add(s.display_name);
            });
        }

        let options = new Array<FilterOption>;
        set.forEach(c => {
            options.push({ text: c, checked: true });
        });

        options.sort(function (a: FilterOption, b: FilterOption) {
            if (a.text < b.text) return -1;
            if (a.text > b.text) return 1;
            return 0;
        });

        return options;
    }



    /** Marks all of the options as unchecked and refilters
     *  @param  options     The array of FilterOptions to mark as unchecked
     */
    selectNone(options: Array<FilterOption>) {
        options.forEach(option => {
            option.checked = false;
        });
        this.filter();
    }


    /** Marks all of the options as checked and refilters
     *  @param  options     The array of FilterOptions to mark as checked
     */
    selectAll(options: Array<FilterOption>) {
        options.forEach(option => {
            option.checked = true;
        });
        this.filter();
    }


    /** Sends a show filter event to any listeners */
    setFilterVisibility(onOrOff: boolean) {
        this.events.showFilter.emit(onOrOff);
    }

    /** Resets the filters, checking all teh boxes */
    reset() {
        this.indexableFilters.forEach(f => {
            this.selectAll(f.filter.filters);
        });

        this.textFilters.forEach(f => {
            this.selectAll(f.filter.filters);
        });

        this.selectAll(this.countries!.filters);
        this.selectAll(this.species!.filters);
    }


}
